import { ChangeDetectorRef, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterLink } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { FuseCardComponent } from '@fuse/components/card';

@Component({
  selector: 'app-services-type03',
  standalone: true,
  imports: [MatIconModule, FuseCardComponent, RouterLink],
  templateUrl: './services-type03.component.html',
  styleUrl: './services-type03.component.scss'
})
export class ServicesType03Component {

  public view: any = {

  };
  constructor(private _cd: ChangeDetectorRef, private _router: Router, private _tfmService : TFMService) {  }

  ngOnInit(): void {
    this._tfmService.getSite().then(res => {
      this.view.site = res;

      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
      this._tfmService.log(this.view);

    });
  }
}
